import React from "react";
//components
import { Column, Row } from "components/Layout/Grid";
import { TitleList } from "pages/Quotes/components/generics/Modal/FinancialPendingMatterModal/TitleList";
import { FinancialPendingMatterCloseButton, FinancialPendingMatterCloseButtonRow, FinancialPendingMatterModalColumn, FinancialPendingMatterModalContainer, FinancialPendingMatterModalRow, FinancialPendingMatterModalText, FinancialPendingMatterModalTitle, FinancialPendingMatterModalValue, TitleListContainer } from "./styles";
//interfaces
import { IFinancialPendingMatterModal } from "./interface";
//context
import { useDetailsQuoteContext } from "contexts/DetailsQuote";
//utils
import { currencyOutputNumber } from "utils/CurrencyOutput";

const FinancialPendingMatterModal: React.FC<IFinancialPendingMatterModal> = (props) => {
  const {
    financialCreditInformations,
    handleCloseFinancialPendingMatterModal,
  } = props;

  const { quoteDetail } = useDetailsQuoteContext();

  const titleAmount = quoteDetail?.financialPending.length;
  const totalLimit = financialCreditInformations[0]?.limiteCredito;
  const usedLimit = financialCreditInformations && (financialCreditInformations[0]?.titulosAbertos + financialCreditInformations[0]?.pedidosPendentes)

  const totalAmount = quoteDetail?.financialPending.reduce(function(accumulator, financialPendingItem){ 
    return accumulator + financialPendingItem.valorPendencia
  }, 0);

  return (
    <FinancialPendingMatterModalContainer>
      <FinancialPendingMatterModalRow>
        <FinancialPendingMatterModalTitle size={14} color={'#0E4C54'}>
          Pendências financeiras
        </FinancialPendingMatterModalTitle>
      </FinancialPendingMatterModalRow>

      <FinancialPendingMatterModalRow>
        <Column className="flex-5 mb-2">
          <FinancialPendingMatterModalText>Limite total</FinancialPendingMatterModalText>
          <Row>
            <FinancialPendingMatterModalValue size={16} color={'#0E4C54'}>{currencyOutputNumber(totalLimit)}</FinancialPendingMatterModalValue>
          </Row>
        </Column>

        <FinancialPendingMatterModalColumn>
          <FinancialPendingMatterModalText>Limite utilizado</FinancialPendingMatterModalText>
          <Row>
            <FinancialPendingMatterModalValue size={16} color={'#14A86B'}>{currencyOutputNumber(usedLimit)}</FinancialPendingMatterModalValue>
          </Row>
        </FinancialPendingMatterModalColumn>
      </FinancialPendingMatterModalRow>

      <FinancialPendingMatterModalRow>
        <Column className="flex-5 mb-2">
          <FinancialPendingMatterModalText>Qtd. de títulos</FinancialPendingMatterModalText>
          <Row>
            <FinancialPendingMatterModalValue size={16} color={'#E02828'}>{titleAmount}</FinancialPendingMatterModalValue>
          </Row>
        </Column>

        <FinancialPendingMatterModalColumn>
          <FinancialPendingMatterModalText>Valor total</FinancialPendingMatterModalText>
          <Row>
            <FinancialPendingMatterModalValue size={16} color={'#E02828'}>{currencyOutputNumber(totalAmount!)}</FinancialPendingMatterModalValue>
          </Row>
        </FinancialPendingMatterModalColumn>
      </FinancialPendingMatterModalRow>
      <TitleListContainer>
        {
          quoteDetail?.financialPending.map((financialPendingItem) => (
            <TitleList
              key={financialPendingItem.numeroDocumento}
              titleText={financialPendingItem.numeroDocumento} 
              titleValue={financialPendingItem.valorPendencia} 
              issueDate={financialPendingItem.dataEmissao} 
              expirationDate={financialPendingItem.dataVencimento} 
              dayDelayNumber={financialPendingItem.atrasoDias} 
            />
          ))
        }
      </TitleListContainer>
      <FinancialPendingMatterCloseButtonRow>
        <FinancialPendingMatterCloseButton width={140} color="#FFFFFF" onClick={handleCloseFinancialPendingMatterModal}>
          Fechar
        </FinancialPendingMatterCloseButton>
      </FinancialPendingMatterCloseButtonRow>
    </FinancialPendingMatterModalContainer>
  );
};

export default FinancialPendingMatterModal;